import { render, staticRenderFns } from "./TebligatList.vue?vue&type=template&id=c4cfb7dc"
import script from "./TebligatList.vue?vue&type=script&lang=ts"
export * from "./TebligatList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports